module.exports = __webpack_public_path__ + "img/GEMA_Logo_Frei_RGB.1d60a5fa.jpg";